import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Send from './icon-send.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Send {...validProps} />;
}
SvgComponent.iconName = 'send';

/**
 * @deprecated This is a legacy icon
 */
export const SendIcon = svgIconWrapper(SvgComponent);
